export default __webpack_public_path__ + "static/media/041.01001265.jpg";